import { render } from "./BarChartMonth.vue?vue&type=template&id=532fb257"
import script from "./BarChartMonth.vue?vue&type=script&lang=js"
export * from "./BarChartMonth.vue?vue&type=script&lang=js"
script.render = render

export default script